import React, { useRef } from 'react';
import Slider from "react-slick";

const ProductSliderV1 = ({ photos }) => {
  const sliderOneRef = useRef()
  const sliderTwoRef = useRef()
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const settingsTwo = {
    swipeToSlide: true,
    focusOnSelect: true,
    slidesToShow: 6,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  }

  return <div className="ltn__img-slider-area mb-90">
    <div className="container-fluid">
      <div className="slider-one">
        <Slider
          {...settings}
          asNavFor={sliderTwoRef.current}
          ref={sliderOneRef}>
          {photos?.map(photoSrc => (
            <div key={photoSrc} className="slider-item">
              <div className="ltn__img-slide-item-4">
                <a href={photoSrc} data-rel="lightcase:myCollection">
                  <img src={photoSrc} alt="" />
                </a>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="slider-two">
        <Slider
          asNavFor={sliderOneRef.current}
          ref={sliderTwoRef}
          {...settingsTwo}
        >
          {photos?.map(photoSrc => (
            <div key={`${photoSrc}-2`} className="slider-item">
              <div className="ltn__img-slide-item-4">
                <img src={photoSrc} alt="Image" />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  </div>
}

export default ProductSliderV1